import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HizmetlerPage from "../pages/hizmetler/page";
import HakkimizdaPage from "../pages/hakkimizda/page";
import YorumlarPage from "../pages/yorumlar/page";
import IletisimPage from "../pages/iletisim/page";
import HizmetDetayPage from "../pages/hizmet-detay/page";
import BlogPage from "../pages/blog/page";
import BlogDetayPage from "../pages/blog-detay/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hizmetler",
    element: <HizmetlerPage />,
  },
  {
    path: "/hizmetler/:slug",
    element: <HizmetDetayPage />,
  },
  {
    path: "/hakkimizda",
    element: <HakkimizdaPage />,
  },
  {
    path: "/yorumlar",
    element: <YorumlarPage />,
  },
  {
    path: "/iletisim",
    element: <IletisimPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetayPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
